/* Raíces · rl-evl · ficha (try.shopeverly.shop/lds-np) y página de oferta (get.shopeverly.shop/checkout-st-lds-np). 23-oct-2026
   · Galerías con scroll nativo (scroll-snap): índice por posición, miniaturas y flechas sincronizadas (swipe real en móvil).
   · Desplegables. · Botones de la ficha → página de oferta CONSERVANDO la query string (UTM, fbclid), como el original (no añaden).
   · Barra fija inferior de la ficha. · Fecha de entrega «Recíbelo entre…» (días hábiles).
   · Oferta: paquetes (radio) → resumen y botón; resumen desplegable; cuenta atrás; «COMPLETAR MI PEDIDO» = POST /cart/add.js con la variante
     (rl-ck, primer script del <head>, vacía el carrito, deja pasar la petición ORIGINAL — product_added_to_cart — y lleva a /checkout).
   ES5 (WebView de Facebook/Instagram). Idempotente (data-rle-bound) y escucha shopify:section:load. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, k) { k = k || 'rleBound'; if (!el || el.dataset[k]) return false; el.dataset[k] = '1'; return true; }
  var DESK = window.matchMedia ? window.matchMedia('(min-width: 768px)') : { matches: false };

  /* ---------- galería ---------- */
  function initGal(g) {
    if (!once(g)) return;
    var stage = $('[data-rle-stage]', g), slides = stage ? $$('.rle-gal__slide', stage) : [];
    if (!stage || slides.length < 2) return;
    var ths = $$('[data-rle-th]', g), prev = $('[data-rle-prev]', g), next = $('[data-rle-next]', g), thBox = $('[data-rle-thumbs]', g), cur = -1, raf = 0;
    function idx() {
      var w = stage.clientWidth || 1, i = Math.round(stage.scrollLeft / w);
      return Math.max(0, Math.min(slides.length - 1, i));
    }
    function mark() {
      raf = 0; var i = idx(); if (i === cur) return; cur = i;
      ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      var t = ths[i];
      if (t && thBox && thBox.scrollWidth > thBox.clientWidth + 1) {
        var l = t.offsetLeft - thBox.offsetLeft - thBox.clientWidth / 2 + t.offsetWidth / 2;
        try { thBox.scrollTo({ left: l, behavior: 'smooth' }); } catch (e) { thBox.scrollLeft = l; }
      }
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var l = i * stage.clientWidth;
      try { stage.scrollTo({ left: l, behavior: 'smooth' }); } catch (e) { stage.scrollLeft = l; }
    }
    stage.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(mark); });
    ths.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go((cur < 0 ? 0 : cur) - 1); });
    if (next) next.addEventListener('click', function () { go((cur < 0 ? 0 : cur) + 1); });
    mark();
  }

  /* ---------- desplegables ---------- */
  function initAcc(b) {
    if (!once(b)) return;
    b.addEventListener('click', function () {
      var it = b.parentNode, open = !it.classList.contains('is-open');
      it.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- botones de la ficha → oferta con la query string ---------- */
  function conQuery(href) {
    var q = location.search || '';
    if (!q || q === '?') return href;
    var base = href.split('#')[0], hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#')) : '';
    return base + (base.indexOf('?') > -1 ? '&' + q.slice(1) : q) + hash;
  }
  function initIr(a) {
    if (!once(a)) return;
    var base = a.getAttribute('href') || '/pages/oferta-drenaje-linfatico';
    a.dataset.rleBase = base;
    a.setAttribute('href', conQuery(base));
    a.addEventListener('click', function () { a.setAttribute('href', conQuery(a.dataset.rleBase)); });
  }

  /* ---------- barra fija ---------- */
  function initFija(bar) {
    if (!once(bar)) return;
    var raf = 0;
    function check() {
      raf = 0;
      var ref = $('.rle-hero .rle-btn');
      if (!ref) { bar.hidden = false; return; }
      bar.hidden = ref.getBoundingClientRect().bottom > 0;
    }
    function onS() { if (!raf) raf = requestAnimationFrame(check); }
    document.addEventListener('scroll', onS, { passive: true, capture: true });
    window.addEventListener('resize', onS);
    check();
  }

  /* ---------- fecha de entrega (días hábiles, lunes a viernes) ---------- */
  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function masHabiles(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function fmt(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + MESES[d.getMonth()]; }
  function initEnvio(p) {
    if (!once(p)) return;
    var tpl = p.getAttribute('data-tpl') || '', mn = parseInt(p.getAttribute('data-min'), 10) || 5, mx = parseInt(p.getAttribute('data-max'), 10) || 8, s = $('span', p);
    if (!tpl || !s || tpl.indexOf('[fecha') < 0) return;
    var hoy = new Date();
    s.textContent = tpl.replace('[fecha1]', fmt(masHabiles(hoy, mn))).replace('[fecha2]', fmt(masHabiles(hoy, Math.max(mn, mx))));
  }

  /* ---------- oferta: paquetes, resumen y compra ---------- */
  function initBuy(box) {
    if (!once(box)) return;
    var packs = $$('[data-rlk-pack]', box), atc = $('[data-rlk-atc]', box), err = $('[data-rlk-err]', box);
    var sum = $('[data-rlk-sum]', box), tog = $('[data-rlk-sumtoggle]', box), lbl = $('[data-rlk-sumlbl]', box);
    function set(sel, val) { $$(sel, box).forEach(function (el) { el.textContent = val; }); }
    function sel(p) {
      packs.forEach(function (x) { var on = x === p; x.classList.toggle('is-sel', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var v = p.getAttribute('data-variant');
      if (atc) atc.setAttribute('data-variant', v);
      set('[data-rlk-total]', p.getAttribute('data-price'));
      set('[data-rlk-sprice]', p.getAttribute('data-price'));
      set('[data-rlk-ssub]', p.getAttribute('data-price'));
      set('[data-rlk-stot]', p.getAttribute('data-price'));
      set('[data-rlk-scmp]', p.getAttribute('data-cmp') || '');
      set('[data-rlk-soff]', p.getAttribute('data-off') || '');
      set('[data-rlk-sname]', p.getAttribute('data-name') || '');
      $$('[data-rlk-simg]', box).forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-rlk-simg') === v); });
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function () { sel(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel(p); } });
    });
    function etiqueta() {
      if (!sum || !lbl || !tog) return;
      var abierto = DESK.matches ? !sum.classList.contains('is-closed') : sum.classList.contains('is-open');
      lbl.textContent = lbl.getAttribute(abierto ? 'data-hide' : 'data-show');
      tog.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    }
    if (tog && sum) {
      tog.addEventListener('click', function () { if (DESK.matches) sum.classList.toggle('is-closed'); else sum.classList.toggle('is-open'); etiqueta(); });
      if (DESK.addEventListener) DESK.addEventListener('change', etiqueta); else if (DESK.addListener) DESK.addListener(etiqueta);
      etiqueta();
    }
    if (atc) atc.addEventListener('click', function () {
      var id = parseInt(atc.getAttribute('data-variant'), 10);
      if (!id || atc.classList.contains('is-busy')) return;
      atc.classList.add('is-busy'); atc.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
      function libre() { atc.classList.remove('is-busy'); atc.removeAttribute('aria-busy'); }
      /* cuerpo tal cual: rl-ck lo deja pasar y, como la variante está en regalos.config.directo, vacía, añade y va a /checkout */
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.text(); })
        .then(function () { if (!window.rlCK) window.location.href = '/checkout'; })
        .catch(function () { if (err) err.hidden = false; libre(); });
      setTimeout(libre, 8000);
    });
  }

  /* ---------- cuenta atrás (desde N minutos en cada carga, como el original) ---------- */
  function initReloj(el) {
    if (!once(el)) return;
    var fin = Date.now() + (parseInt(el.getAttribute('data-min'), 10) || 10) * 60000, t;
    function tick() {
      var s = Math.max(0, Math.round((fin - Date.now()) / 1000)), m = Math.floor(s / 60), r = s % 60;
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
      if (s <= 0) clearInterval(t);
    }
    tick(); t = setInterval(tick, 1000);
  }

  function init() {
    $$('[data-rle-gal]').forEach(initGal);
    $$('[data-rle-acc]').forEach(initAcc);
    $$('a[data-rle-ir]').forEach(initIr);
    $$('[data-rle-fija]').forEach(initFija);
    $$('[data-rle-envio]').forEach(initEnvio);
    $$('[data-rlk-buy]').forEach(initBuy);
    $$('[data-rlk-reloj]').forEach(initReloj);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
